<template>
  <div>
    <loading :active.sync="isLoading" background-color="#D0D0D0	">
      <div class="loadingio-spinner-eclipse-y24d302hfm">
        <div class="ldio-f9ujl5oazv5">
          <div></div>
        </div>
      </div>
    </loading>

    <div v-if="show">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    data() {
      return {
        isLoading: true,
        show: false,
        access_token: '',
      }
    },

    metaInfo: {
      htmlAttrs: {
        lang: 'zh-tw',
      },

      meta: [
        {
          name: 'description',
          content:
            '展昭國際企業群成立於1985年10月,是台灣第一家大型民間專業展覽公司,主要從事籌辦大型國際展覽會及會議,出版展覽專刊雜誌,光碟,代理世界各國知名展會徵展業務及建構網路數位線上展覽。',
        },
        {
          name: 'keywords',
          content: '展昭展覽網,展昭,展覽,展覽行銷,展覽會,參展,世貿,南港展覽館',
        },
        {
          name: 'apple-mobile-web-app-title',
          content: '展昭展覽網',
        },

        {
          name: 'application-name',
          content: '展昭展覽網',
        },
      ],
    },

    created() {
      //驗證是否為登入狀態

      const vm = this
      let nowPage = location.href
      let activePage = nowPage.split('/')[4]

      if (activePage !== 'logout') {
        const url = 'https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated'
        const info = null

        vm.$http.post(url, info).then(function (response) {
          // console.log(response)

          if (response.data == 200) {
            sessionStorage.setItem('access', '200')

            let lastPage = document.referrer
            let lastdomain = lastPage.split('/')[2]
            let noAccounts = lastPage.split('/')[3] //排除網址有accounts

            if (lastdomain == 'www.chanchao.com.tw' && noAccounts !== 'accounts') {
              if (activePage == 'forgetPw' || activePage == 'resetPw') {
                vm.isLoading = false
                vm.show = true
              } else {
                alert('您目前已是登入狀態！')

                //如果網域為展昭
                document.location.href = lastPage //問題點
              }
            } else {
              //因重設密碼有設參數，因此擷取?前面的字串為判斷
              let activePage2 = activePage.split('?')[0]

              if (activePage2 == 'signup') {
                alert('您目前已是登入狀態！')
                document.location.href = 'https://www.chanchao.com.tw/member'
              } else if (activePage2 == 'forgetPw' || activePage2 == 'resetPw') {
                vm.isLoading = false
                vm.show = true
              } else {
                alert('您目前已是登入狀態！')
                document.location.href = 'https://www.chanchao.com.tw/'
              }
            }
          } else if (response.data == 250) {
            const url = 'https://www.chanchao.com.tw/apiLogin/v1/refresh'
            vm.$http.post(url).then(function (response) {
              if (response) {
                vm.isLoading = false
                vm.show = true
                sessionStorage.setItem('access', '200')
                // // console.log('accesstoken正確但過期')
              } else {
                vm.isLoading = false
                vm.show = true
                sessionStorage.setItem('access', '')
                sessionStorage.removeItem('access')
                // // console.log('沒回傳任何值')
              }
            })
          } else {
            vm.isLoading = false
            vm.show = true
            sessionStorage.setItem('access', '')
            sessionStorage.removeItem('access')
            // // console.log('Cookie 未有 accesstoken')
          }
        })
      } else {
        vm.isLoading = false
        vm.show = true
      }
    },
  }
</script>

<style lang="scss">
  @keyframes ldio-f9ujl5oazv5 {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .ldio-f9ujl5oazv5 div {
    position: absolute;
    animation: ldio-f9ujl5oazv5 1s linear infinite;
    width: 160px;
    height: 160px;
    top: 20px;
    left: 20px;
    border-radius: 50%;
    box-shadow: 0 4px 0 0 #777b7c;
    transform-origin: 80px 82px;
  }
  .loadingio-spinner-eclipse-y24d302hfm {
    width: 200px;
    height: 200px;
    display: inline-block;
    overflow: hidden;
  }
  .ldio-f9ujl5oazv5 {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
  }
  .ldio-f9ujl5oazv5 div {
    box-sizing: content-box;
  }
</style>
